import React from "react";

const Modal = ({ open, title, children, onClose, footer }) => {
  if (!open) return null;
  return (
    <div
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 p-3"
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className="flex max-h-[90vh] w-[min(840px,94vw)] flex-col rounded-xl bg-white shadow-xl"
      >
        <div className="flex flex-shrink-0 items-center justify-between border-b border-gray-200 p-4">
          <h3 className="m-0 text-base font-semibold text-gray-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-7 w-7 items-center justify-center rounded hover:bg-gray-100"
          >
            <span className="text-xl leading-none">×</span>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
        <div className="flex flex-shrink-0 justify-end gap-2 border-t border-gray-200 p-4">
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Modal;


